import {
  Component,
  forwardRef,
  Input,
  OnInit,
  ViewContainerRef,
  AfterViewInit,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { DropdownService } from '../services/dropdown.service';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
})
export class MenuItemComponent implements OnInit, AfterViewInit,OnChanges {
  constructor(
    private dropDown: DropdownService,
    private view: ViewContainerRef
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    this.dropDown.setMenuItems(this.value);
    //  this.handlePreChecked();     
  }
  ngAfterViewInit(): void {
    this.handlePreChecked();
  }
  handlePreChecked() {
    const element = this.view.element.nativeElement.querySelector(
      'input[type="checkbox"]'
    );
    
    
    let defaultValue:any = ''
    if (Array.isArray(this.dropDown.defaultValue)) {
      defaultValue = this.dropDown.defaultValue;
    } else {
      defaultValue = `${this.dropDown.defaultValue}`.split(',');
    }


    
     if (this.dropDown.handleNA) {
       this.view.element.nativeElement
         .querySelectorAll('input[type=checkbox]')
         .forEach((element: any) => {
           element.setAttribute('data-value', this.value);
         });
     }
     
    if (
      element instanceof HTMLInputElement &&
      (element.type === 'checkbox' || element.type === 'radio') &&
      this.dropDown.multiple &&
      defaultValue.includes(this.value)
      ) {
        
      
      element.checked = true;     
      this.setCheckedValue(element);
    }
    if (this.selectAll) {
      this.view.element.nativeElement.setAttribute('data-select-all', 'true');
    }
    if (this.value) {
      this.view.element.nativeElement.setAttribute('data-value', this.value);
    }

   
    if (this.dropDown.isSearchable) {
      this.dropDown.dropDownValue.subscribe((value) => {
        if (
          this.value &&
          this.value.toLowerCase().includes(value.toLowerCase())
        ) {
          this.view.element.nativeElement.style.display = 'block';
        } else {
          this.view.element.nativeElement.style.display = 'none';
        }
      });
    }
  }
  selected!: string | number;
  @Input()
  value!: any;
  @Input() selectAll: boolean = false;
  @Input() defaultSelected: boolean = false;
  @Input() disabled:boolean = false;
  hadleClick(event: any) {
    const element: any = event.target;
    this.dropDown.isInputDirty = true;
    this.setCheckedValue(element);    
  }
  handleFocus() {
    this.dropDown.openMenu();
  }
  setCheckedValue(element: any) {
    if (this.disabled) {
      return; // Exit if the menu item is disabled
    }
    if (
      element instanceof HTMLInputElement &&
      (element.type === 'checkbox' || element.type === 'radio') &&
      this.dropDown.multiple
    ) {
      this.dropDown.isSelectAll = this.selectAll;
      if (element.checked && this.value) {
        if (this.selectAll) {
          this.dropDown.setSelectAll(this.value);
          return;
        }
        if (element.type === 'radio') {
          this.dropDown.multipleValues.next([]);
        }
        this.dropDown.setSelectedMenu(this.value);
        // this.dropDown.setDropDownValue('')
        return;
      }
      this.dropDown.removeMutipleValue(this.value);
      this.selectAll && this.dropDown.setSelectAll(null);
    }
    if (!this.dropDown.multiple) {
      this.dropDown.setSelectedMenu(this.value);
      this.dropDown.closeMenu();
    }
  }
  ngOnInit(): void {
    this.dropDown.dropDownState.subscribe((state) => {
      this.selected = state.selectedMenu;
    });
    if (this.defaultSelected) {
      this.dropDown.setSelectedMenu(this.value);
      this.dropDown.setInputblur(true);
    }
    this.dropDown.setMenuItems(this.value);
  }
 
}
